module.exports = __webpack_public_path__ + "img/bm.0fdff6d2.svg";